//import liraries
import React from "react";
import { View, Text, StyleSheet, TouchableHighlight } from "react-native";
import { COLORS } from "../constant";
// create a component
const CButton = ({ isDisabled, title, onPress, SM, XS, style = {} }) => {

  let extBtnStyle = {};
  let extBtnTextStyle = {};
  if (SM) {
    extBtnStyle = { height: 32, borderRadius: 16, paddingHorizontal: 10 };
    extBtnTextStyle = { ...styles.btnSMText };
  }
  if (XS) {
    extBtnStyle = { height: 22, borderRadius: 12, paddingHorizontal: 14 };
    extBtnTextStyle = { ...styles.btnSMText };
  }

  if (isDisabled == true) {
    return (
      <View style={{ ...styles.btnDisable, ...extBtnStyle, ...style }}>
        <Text style={{ ...styles.btnText, ...extBtnTextStyle }}>{title}</Text>
      </View>
    );
  }
  return (
    <TouchableHighlight style={{ ...styles.btnActive, ...extBtnStyle, ...style }} onPress={onPress} activeOpacity={1} underlayColor="#8E1820">
      <Text style={{ ...styles.btnText, ...extBtnTextStyle }}>{title}</Text>
    </TouchableHighlight>
  );
};

CButton.defaultProps = {
  isDisabled: false,
  SM: false,
  XS: false
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  btnDisable: {
    backgroundColor: "rgba(2, 18, 44, 0.2)",
    width: "100%",
    height:36,
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    marginVertical: 10,
    borderRadius: 23,
    shadowOpacity: 0,
    elevation: 0,
    shadowRadius: 0,
    shadowOffset: { width: 1, height: 13 },
    position: "relative",
    zIndex: 5,
  },
  btnActive: {
    backgroundColor: "#BD2D37",
    width: "100%",
    height:36,
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    marginVertical: 10,
    borderRadius: 23,
    shadowColor: "rgba(189,45,55,0.4)",
    shadowOpacity: 1.5,
    elevation: 2,
    shadowRadius: 10,
    shadowOffset: { width: 1, height: 1 },
    position: "relative",
    zIndex: 5,
  },
  btnText: {
    color: COLORS.white,
    textAlign: "center",
    fontFamily: "Inter",
    lineHeight:18,
    fontSize:14,
  },
  btnSMText: {
    color: COLORS.white,
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: 12,
    lineHeight: 17
  },
  btnXSText: {
    color: COLORS.white,
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: 10,
    lineHeight: 12
  },

});

export default CButton;
